import { findIndex } from 'ramda';

// This wizard helper is only for the logic pertaining to the wizard itself, do not include business type specific logic

export var getNextStepIndex = function getNextStepIndex(allStepsKeys, skippedSteps, currentStepIndex) {
  var nextStepKey = allStepsKeys.reduce(function (firstFound, stepKey, stepIndex) {
    if (!firstFound && foundPreviousStep(stepIndex, currentStepIndex, skippedSteps, stepKey)) {
      firstFound = stepKey;
    }
    return firstFound;
  }, null);
  return Math.min(findIndex(function (stepKey) {
    return stepKey === nextStepKey;
  }, allStepsKeys), allStepsKeys.length - 1);
};
var foundPreviousStep = function foundPreviousStep(stepIndex, currentStepIndex, skippedSteps, stepKey) {
  var isStepSkipped = skippedSteps.some(function (skippedStep) {
    return skippedStep === stepKey;
  });
  return stepIndex > currentStepIndex && !isStepSkipped;
};
export var getPreviousStepIndex = function getPreviousStepIndex(allStepsKeys, completedSteps, currentStepIndex) {
  var previousStepKey = allStepsKeys.reduce(function (lastFound, stepKey, stepIndex) {
    if (stepIndex < currentStepIndex && completedSteps[stepKey]) {
      lastFound = stepKey;
    }
    return lastFound;
  }, null);
  if (previousStepKey) {
    return Math.max(findIndex(function (stepKey) {
      return stepKey === previousStepKey;
    }, allStepsKeys), 0);
  } else {
    return previousStepKey;
  }
};